import Vue from 'vue';

export default {
  namespaced: true,
  state: () => ({
    calls: []
  }),
  mutations: {
    setCall(state, data) {
      Vue.prototype.$dbHandler
        .addRecord("pending_calls", data)
        .then(() => {
          state.calls.push(data);
        })
        .catch((err) => {});
    },
  },
  actions: {}
}
